/*
  Persona header: dropdown panels, localization submit, mobile drawer.

  Panels open on hover only where the pointer can hover precisely; touch and
  keyboard use click / Enter. Escape and an outside click close them.
*/
(function () {
  'use strict';

  var header = document.querySelector('[data-ps-header]');
  if (!header) return;

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var closeTimer = null;

  function panelFor(trigger) {
    return document.getElementById(trigger.getAttribute('aria-controls'));
  }

  function closeAll(except) {
    header.querySelectorAll('[data-ps-panel-trigger][aria-expanded="true"]').forEach(function (t) {
      if (t === except) return;
      t.setAttribute('aria-expanded', 'false');
      var p = panelFor(t);
      if (p) p.hidden = true;
    });
  }

  function open(trigger) {
    closeAll(trigger);
    trigger.setAttribute('aria-expanded', 'true');
    var p = panelFor(trigger);
    if (p) p.hidden = false;
  }

  function close(trigger) {
    trigger.setAttribute('aria-expanded', 'false');
    var p = panelFor(trigger);
    if (p) p.hidden = true;
  }

  header.querySelectorAll('[data-ps-panel-trigger]').forEach(function (trigger) {
    var item = trigger.closest('.ps-hdr__item');
    var panel = panelFor(trigger);

    trigger.addEventListener('click', function () {
      if (trigger.getAttribute('aria-expanded') === 'true') close(trigger);
      else open(trigger);
    });

    // Hover-open, with a short grace period so moving the pointer from the
    // trigger into the panel below doesn't close it.
    [item, panel].forEach(function (el) {
      if (!el) return;
      el.addEventListener('mouseenter', function () {
        if (!canHover.matches) return;
        clearTimeout(closeTimer);
        open(trigger);
      });
      el.addEventListener('mouseleave', function () {
        if (!canHover.matches) return;
        closeTimer = setTimeout(function () { close(trigger); }, 160);
      });
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var openTrigger = header.querySelector('[data-ps-panel-trigger][aria-expanded="true"]');
    if (openTrigger) { close(openTrigger); openTrigger.focus(); }
    if (drawer && !drawer.hidden) closeDrawer();
  });

  document.addEventListener('click', function (e) {
    if (!header.contains(e.target)) closeAll();
  });

  // Localization: the native select is visually hidden behind the label, and
  // submits as soon as a country is chosen.
  header.querySelectorAll('[data-ps-autosubmit]').forEach(function (sel) {
    sel.addEventListener('change', function () { sel.form.submit(); });
  });

  /* ---------- mobile drawer ---------- */

  var drawer = header.querySelector('[data-ps-drawer]');
  var opener = header.querySelector('[data-ps-drawer-open]');

  function openDrawer() {
    if (!drawer) return;
    drawer.hidden = false;
    document.body.classList.add('ps-lock');
    opener.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      var first = drawer.querySelector('.ps-drawer__close');
      if (first) first.focus();
    });
  }

  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.body.classList.remove('ps-lock');
    opener.setAttribute('aria-expanded', 'false');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(function () { drawer.hidden = true; opener.focus(); }, reduced ? 0 : 280);
  }

  if (opener) opener.addEventListener('click', openDrawer);
  if (drawer) {
    drawer.querySelectorAll('[data-ps-drawer-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });
    drawer.querySelectorAll('[data-ps-drawer-sub]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = document.getElementById(btn.getAttribute('aria-controls'));
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        if (sub) sub.hidden = expanded;
      });
    });
    // Keep focus inside the open drawer.
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = drawer.querySelectorAll('a[href], button:not([disabled])');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }
})();
